import { Roles } from 'roles';
import { Meteor } from 'meteor/meteor';
import _ from 'lodash';

export const partner = new Roles.Role('partner');

/*
 *	List Permissions
 *	Manage page access
 */


partner.allow('calendar.list', false);
partner.allow('orders.list', true);
partner.allow('flights.list', true);
partner.allow('flights-type.list', true);
partner.allow('places.list', false);
partner.allow('prices.list', false);
partner.allow('promotions.list', false);
partner.allow('options.list', false);
partner.allow('users.list', false);
partner.allow('montgolfieres.list', true);
partner.allow('statistics.list', false);
partner.allow('planifications.list', false);


/*
 *	Users
 */
partner.allow('users.insert', false);
partner.allow('users.update', (userId, doc) => {
	return doc._id === userId;
});
partner.deny('users.update', (userId, doc, fields, modifier) => {
	return _.includes(fields, 'roles')
			 || (modifier &&
					 modifier['$set'] &&
						 modifier['$set']['roles'] &&
							 (modifier['$set']['roles'].length > 1 || modifier['$set']['roles'][0] !== "partner"));
});
partner.allow('users.remove', false);

/*
 *	Montgolfieres
 */
partner.allow('montgolfieres.insert', false);
partner.allow('montgolfieres.update', false);
partner.allow('montgolfieres.remove', false);

/*
 *  Flights
 */
partner.allow('flights.insert', false);
partner.allow('flights.update', false);
partner.allow('flights.remove', false);

/*
 *  Lieux d'envols
 */
partner.allow('places.insert', false);
partner.allow('places.update', false);
partner.allow('places.remove', false);

/*
 *  Prix
 */
partner.allow('prices.insert', false);
partner.allow('prices.update', false);
partner.allow('prices.remove', false);


/*
 *  Flights-type
 */
partner.allow('flights-type.insert', false);
partner.allow('flights-type.update', false);
partner.allow('flights-type.remove', false);

/*
 *  Reservations
 */
partner.allow('reservations.insert', true);
partner.allow('reservations.update', (userId, doc) => {
	return doc.userId == userId;
});
partner.allow('reservations.remove', (userId, doc) => {
	return doc.userId == userId;
});

/*
 *  Alerts
 */
partner.allow('alerts.insert', false);
partner.allow('alerts.update', false);
partner.allow('alerts.remove', false);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/users/roles/partner.js
 **/